var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCallFill = function SvgCallFill(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6072_36538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7778 15.3511C19.6267 15.1733 19.4311 15.0489 19.2 14.9867L16.5867 14.4533C16.3644 14.4178 16.1422 14.4356 15.9378 14.4978C15.7244 14.56 15.5467 14.6667 15.4044 14.8178L13.2889 16.9511C12.6133 16.5689 11.9822 16.16 11.4044 15.7156C10.8267 15.2711 10.2756 14.7911 9.76 14.2756C9.23555 13.7511 8.74667 13.2089 8.30222 12.64C7.84889 12.0711 7.44889 11.4667 7.10222 10.8178L9.28 8.70223C9.41333 8.57779 9.51111 8.41779 9.56444 8.24001C9.61778 8.05334 9.62667 7.83112 9.59111 7.57334L9.04889 4.80001C8.99555 4.5689 8.88 4.38223 8.70222 4.22223C8.52444 4.07112 8.31111 3.99112 8.07111 3.99112H4.98667C4.70222 3.99112 4.47111 4.0889 4.28444 4.27556C4.09778 4.46223 4 4.70223 4 4.98667C4 6.76445 4.40889 8.54223 5.23556 10.3289C6.06222 12.1156 7.22667 13.76 8.72 15.2622C10.2222 16.7645 11.8667 17.9289 13.6533 18.7556C15.44 19.5822 17.2267 19.9911 18.9956 19.9911C19.28 19.9911 19.52 19.8933 19.7067 19.7067C19.8933 19.52 19.9911 19.28 19.9911 19.0045V15.9556C19.9911 15.7245 19.92 15.52 19.7689 15.3422L19.7778 15.3511Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6072_36538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCallFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "call-fill.bf488aab01f793724145271ee8c8d21e.svg";